import { FileText } from '@phosphor-icons/react';

export default FileText;
